var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-img flex-center-children"},[(_vm.showFallbackImg)?_c('FaIcon',{attrs:{"icon":"user-circle"}}):_c('img',{attrs:{"src":_vm.profileImgUrl,"alt":"profile"},on:{"error":function($event){_vm.hasImgErr = true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }